import { State } from "../../types";
import { blockIsTable } from "../../util";
import { isValidXml } from "../util";

export type UpdateBlockTextAction = Readonly<{
  blockId: string;
  text: string;
  type: "UPDATE BLOCK TEXT";
}>;

export const updateBlockText = (state: State, action: UpdateBlockTextAction): State => {
  if (state.readonly) {
    return state;
  }
  if (!(action.blockId in state.blocks)) {
    return state;
  }
  const block = state.blocks[action.blockId];
  if (blockIsTable(block)) {
    return state;
  }
  return {
    ...state,
    blocks: {
      ...state.blocks,
      [action.blockId]: {
        ...block,
        text: action.text,
        validXml: isValidXml(action.text),
      },
    },
  };
};
